import { LayoutTemplate, Plus, Trash2 } from "lucide-react";
import { inputCls, labelCls, ICON_OPTIONS } from "./constants";

export default function HomeSection({ brand, setBrand }) {
  return (
    <section>
      <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg mb-4">
        <LayoutTemplate size={18} className="text-[#1f3a8a]" /> Sekcja „Sprawdź swój zasięg” i pozostałe teksty
      </h3>

      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-4">
        <div className="border-b border-slate-200 pb-4 space-y-3">
          <div className="text-xs font-bold text-slate-600 uppercase tracking-wider">Kafelek „Zasięg" na stronie głównej</div>
          <label className="flex items-center gap-2 text-sm text-slate-700 font-semibold">
            <input
              type="checkbox"
              data-testid="coverage-card-toggle"
              checked={brand.coverage_card_visible !== false}
              onChange={(e) => setBrand({ ...brand, coverage_card_visible: e.target.checked })}
              className="w-4 h-4"
            />
            Pokazuj kafelek na stronie głównej
          </label>
          <div className={brand.coverage_card_visible === false ? "opacity-40 pointer-events-none" : ""}>
            <label className={labelCls}>
              Przejrzystość kafelka: {Math.round((brand.coverage_card_opacity ?? 0.92) * 100)}%
            </label>
            <input
              type="range"
              data-testid="coverage-card-opacity"
              min="30"
              max="100"
              step="1"
              value={Math.round((brand.coverage_card_opacity ?? 0.92) * 100)}
              onChange={(e) => setBrand({ ...brand, coverage_card_opacity: parseInt(e.target.value, 10) / 100 })}
              className="w-full mt-1 accent-[#1f3a8a]"
            />
            <div className="flex justify-between text-[10px] text-slate-400 mt-1">
              <span>Przezroczysty (mapa widoczna)</span>
              <span>Nieprzezroczysty</span>
            </div>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-3">
          <div>
            <label className={labelCls}>Etykieta (nad tytułem)</label>
            <input data-testid="coverage-label" className={inputCls} value={brand.coverage.label} onChange={(e) => setBrand({ ...brand, coverage: { ...brand.coverage, label: e.target.value } })} />
          </div>
          <div className="md:col-span-2">
            <label className={labelCls}>Tytuł zasięgu</label>
            <input data-testid="coverage-title" className={inputCls} value={brand.coverage.title} onChange={(e) => setBrand({ ...brand, coverage: { ...brand.coverage, title: e.target.value } })} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Opis zasięgu</label>
          <textarea data-testid="coverage-subtitle" className={inputCls} rows={2} value={brand.coverage.subtitle} onChange={(e) => setBrand({ ...brand, coverage: { ...brand.coverage, subtitle: e.target.value } })} />
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 mt-4 space-y-4">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider">Nagłówek sekcji abonamentów (na stronie głównej)</div>
        <div className="grid md:grid-cols-3 gap-3">
          <div>
            <label className={labelCls}>Nadtytuł</label>
            <input data-testid="plans-eyebrow" className={inputCls} value={brand.plans_heading.eyebrow} onChange={(e) => setBrand({ ...brand, plans_heading: { ...brand.plans_heading, eyebrow: e.target.value } })} />
          </div>
          <div className="md:col-span-2">
            <label className={labelCls}>Tytuł</label>
            <input data-testid="plans-title" className={inputCls} value={brand.plans_heading.title} onChange={(e) => setBrand({ ...brand, plans_heading: { ...brand.plans_heading, title: e.target.value } })} />
          </div>
        </div>
        <div>
          <label className={labelCls}>Podtytuł</label>
          <input data-testid="plans-subtitle" className={inputCls} value={brand.plans_heading.subtitle} onChange={(e) => setBrand({ ...brand, plans_heading: { ...brand.plans_heading, subtitle: e.target.value } })} />
        </div>
      </div>

      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 mt-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-xs font-bold text-slate-500 uppercase tracking-wider">Kafelki w sekcji zasięgu (Mocny sygnał / Bezpieczeństwo / Prędkość 5G / Roaming UE)</div>
          <button type="button" data-testid="add-top-feature" onClick={() => setBrand({ ...brand, top_features: [...brand.top_features, { icon: "signal", title: "Nowy", desc: "" }] })} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]">
            <Plus size={14} /> Dodaj
          </button>
        </div>
        {brand.top_features.map((f, i) => (
          <div key={i} data-testid={`top-feature-${i}`} className="grid md:grid-cols-[130px_1fr_40px] gap-3 items-end">
            <div>
              <label className={labelCls}>Ikona</label>
              <select data-testid={`tf-icon-${i}`} value={f.icon || "signal"} onChange={(e) => setBrand({ ...brand, top_features: brand.top_features.map((x, idx) => idx === i ? { ...x, icon: e.target.value } : x) })} className={inputCls}>
                {ICON_OPTIONS.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
              </select>
            </div>
            <div>
              <label className={labelCls}>Tytuł</label>
              <input data-testid={`tf-title-${i}`} className={inputCls} value={f.title} onChange={(e) => setBrand({ ...brand, top_features: brand.top_features.map((x, idx) => idx === i ? { ...x, title: e.target.value } : x) })} />
            </div>
            <button type="button" onClick={() => setBrand({ ...brand, top_features: brand.top_features.filter((_, idx) => idx !== i) })} className="text-red-500 hover:text-red-700 pb-2"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 mt-4 space-y-3">
        <div className="flex items-center justify-between">
          <div className="text-xs font-bold text-slate-500 uppercase tracking-wider">Kafelki „dlaczego my” (features)</div>
          <button type="button" data-testid="add-feature" onClick={() => setBrand({ ...brand, features: [...brand.features, { title: "Nowy kafelek", desc: "" }] })} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]">
            <Plus size={14} /> Dodaj
          </button>
        </div>
        {brand.features.map((f, i) => (
          <div key={i} data-testid={`feature-${i}`} className="grid md:grid-cols-[1fr_2fr_40px] gap-3 items-end">
            <div>
              <label className={labelCls}>Tytuł</label>
              <input data-testid={`feature-title-${i}`} className={inputCls} value={f.title} onChange={(e) => setBrand({ ...brand, features: brand.features.map((x, idx) => idx === i ? { ...x, title: e.target.value } : x) })} />
            </div>
            <div>
              <label className={labelCls}>Opis</label>
              <input data-testid={`feature-desc-${i}`} className={inputCls} value={f.desc} onChange={(e) => setBrand({ ...brand, features: brand.features.map((x, idx) => idx === i ? { ...x, desc: e.target.value } : x) })} />
            </div>
            <button type="button" onClick={() => setBrand({ ...brand, features: brand.features.filter((_, idx) => idx !== i) })} className="text-red-500 hover:text-red-700 pb-2"><Trash2 size={16} /></button>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 mt-4 space-y-3">
        <div className="text-xs font-bold text-slate-500 uppercase tracking-wider">Końcowa sekcja CTA (na dole strony głównej)</div>
        <div>
          <label className={labelCls}>Tytuł</label>
          <input data-testid="cta-title" className={inputCls} value={brand.cta_home.title} onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, title: e.target.value } })} />
        </div>
        <div>
          <label className={labelCls}>Podtytuł</label>
          <input data-testid="cta-subtitle" className={inputCls} value={brand.cta_home.subtitle} onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, subtitle: e.target.value } })} />
        </div>

        {/* PRZYCISK GŁÓWNY (czerwony) */}
        <div className="rounded-lg border border-slate-200 bg-white p-3 space-y-2">
          <div className="flex items-center justify-between">
            <div className="text-xs font-bold text-slate-700 uppercase tracking-wider">Przycisk główny (czerwony)</div>
            <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
              <input
                type="checkbox"
                data-testid="cta-primary-enabled"
                checked={brand.cta_home.primary_btn?.enabled !== false}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, primary_btn: { ...(brand.cta_home.primary_btn || {}), enabled: e.target.checked } } })}
                className="w-4 h-4"
              />
              <span className="font-semibold">Pokazuj</span>
            </label>
          </div>
          <div className={`grid md:grid-cols-2 gap-3 ${brand.cta_home.primary_btn?.enabled === false ? "opacity-40 pointer-events-none" : ""}`}>
            <div>
              <label className={labelCls}>Tekst przycisku</label>
              <input
                data-testid="cta-primary-text"
                className={inputCls}
                value={brand.cta_home.primary_btn?.text || ""}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, primary_btn: { ...(brand.cta_home.primary_btn || {}), text: e.target.value } } })}
                placeholder="Zamów kartę SIM"
              />
            </div>
            <div>
              <label className={labelCls}>Dokąd przekierowuje</label>
              <select
                data-testid="cta-primary-url"
                className={inputCls}
                value={brand.cta_home.primary_btn?.url || "/zamow-sim"}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, primary_btn: { ...(brand.cta_home.primary_btn || {}), url: e.target.value } } })}
              >
                <option value="/zamow-sim">/zamow-sim — Formularz zamówienia SIM</option>
                <option value="/przenies-numer">/przenies-numer — Przenieś numer</option>
                <option value="/abonamenty">/abonamenty — Abonamenty</option>
                <option value="/internet-mobilny">/internet-mobilny — Internet mobilny</option>
                <option value="/kontakt">/kontakt — Kontakt</option>
                <option value="/regulamin">/regulamin — Regulamin</option>
                <option value="__custom__">Inny link (podaj poniżej)</option>
              </select>
              {!["/zamow-sim","/przenies-numer","/abonamenty","/internet-mobilny","/kontakt","/regulamin"].includes(brand.cta_home.primary_btn?.url || "/zamow-sim") && (
                <input
                  data-testid="cta-primary-url-custom"
                  className={`${inputCls} mt-2`}
                  value={brand.cta_home.primary_btn?.url === "__custom__" ? "" : (brand.cta_home.primary_btn?.url || "")}
                  onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, primary_btn: { ...(brand.cta_home.primary_btn || {}), url: e.target.value } } })}
                  placeholder="/moja-strona lub https://..."
                />
              )}
            </div>
          </div>
        </div>

        {/* PRZYCISK POBOCZNY (obramowany) */}
        <div className="rounded-lg border border-slate-200 bg-white p-3 space-y-2">
          <div className="flex items-center justify-between">
            <div className="text-xs font-bold text-slate-700 uppercase tracking-wider">Przycisk poboczny (obramowany)</div>
            <label className="flex items-center gap-2 text-sm text-slate-700 cursor-pointer">
              <input
                type="checkbox"
                data-testid="cta-secondary-enabled"
                checked={brand.cta_home.secondary_btn?.enabled !== false}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, secondary_btn: { ...(brand.cta_home.secondary_btn || {}), enabled: e.target.checked } } })}
                className="w-4 h-4"
              />
              <span className="font-semibold">Pokazuj</span>
            </label>
          </div>
          <div className={`grid md:grid-cols-2 gap-3 ${brand.cta_home.secondary_btn?.enabled === false ? "opacity-40 pointer-events-none" : ""}`}>
            <div>
              <label className={labelCls}>Tekst przycisku</label>
              <input
                data-testid="cta-secondary-text"
                className={inputCls}
                value={brand.cta_home.secondary_btn?.text || ""}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, secondary_btn: { ...(brand.cta_home.secondary_btn || {}), text: e.target.value } } })}
                placeholder="Przenieś numer"
              />
            </div>
            <div>
              <label className={labelCls}>Dokąd przekierowuje</label>
              <select
                data-testid="cta-secondary-url"
                className={inputCls}
                value={brand.cta_home.secondary_btn?.url || "/przenies-numer"}
                onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, secondary_btn: { ...(brand.cta_home.secondary_btn || {}), url: e.target.value } } })}
              >
                <option value="/zamow-sim">/zamow-sim — Formularz zamówienia SIM</option>
                <option value="/przenies-numer">/przenies-numer — Przenieś numer</option>
                <option value="/abonamenty">/abonamenty — Abonamenty</option>
                <option value="/internet-mobilny">/internet-mobilny — Internet mobilny</option>
                <option value="/kontakt">/kontakt — Kontakt</option>
                <option value="/regulamin">/regulamin — Regulamin</option>
                <option value="__custom__">Inny link (podaj poniżej)</option>
              </select>
              {!["/zamow-sim","/przenies-numer","/abonamenty","/internet-mobilny","/kontakt","/regulamin"].includes(brand.cta_home.secondary_btn?.url || "/przenies-numer") && (
                <input
                  data-testid="cta-secondary-url-custom"
                  className={`${inputCls} mt-2`}
                  value={brand.cta_home.secondary_btn?.url === "__custom__" ? "" : (brand.cta_home.secondary_btn?.url || "")}
                  onChange={(e) => setBrand({ ...brand, cta_home: { ...brand.cta_home, secondary_btn: { ...(brand.cta_home.secondary_btn || {}), url: e.target.value } } })}
                  placeholder="/moja-strona lub https://..."
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
